import * as _ from 'lodash';
import { FormEvent, useState } from 'react';
import { Alert, Button, FormControl, Col, Form, FormGroup, ControlLabel, Row, Glyphicon, Radio, Modal } from 'react-bootstrap';
import { IAuthRole, ICenterBase, IGroup, IListItem } from '@nkr/models/index';
import { ErrorWrapper } from '../../components/styles';
import { FormWrapper, RoleWrapper } from './styles';
import { UserGroup } from '@nkr/enums/user-group';
import { IAddEditData } from './add-edit-data';
import { useAppHookContext } from '@nkr/utils/rest-api';
// import Roles from './roles';
import PasswordField from '@nkr/components/security/password-field';

interface IProps {
    show: boolean,
    data: IAddEditData,
    isAdmin: boolean,
    userGroups: IGroup[],
    roles: IAuthRole[],
    centers: ICenterBase[],
    micrositeCoaches: IListItem[],
    courierVendors: IListItem[],
    organTypeList: IListItem[],
    opoList: IListItem[],
    onFieldChange: (field: string, value: any) => void,
    onRoleChange: (roleId: number) => void,
    onSave: (closeDetails: boolean) => void,
    onCancel: () => void
}

interface IValidation {
    firstName: boolean,
    lastName: boolean,
    email: boolean,
    username: boolean,
    password: boolean,
    confirmPassword: boolean,
    group: boolean,
    courierVendor: boolean,
    center: boolean,
    contact: boolean,
    opo: boolean
}

const validationInitialState: IValidation = {
    firstName: true,
    lastName: true,
    email: true,
    username: true,
    password: true,
    confirmPassword: true,
    group: true,
    courierVendor: true,
    center: true,
    contact: true,
    opo: true
}

const AddEdit = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    const [validation, setValidation] = useState(validationInitialState);
    const [dirty, setDirty] = useState(false);

    const sendsVerification = props.data != null && props.data.id == 0 && props.data.groupId == UserGroup.OpoAdmin;

    const handleFieldChange =(e:FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>)=> {
        let { name, value } = e.currentTarget;
        props.onFieldChange(name, value);
    };

    const handlePasswordFieldChange = (field: string, value: any) => {
        props.onFieldChange(field, value);
    };

    const handleRoleToggle = (roleId: number) => {
        props.onRoleChange(roleId);
    };

    const handleSave = (closeDetails: boolean) => {
        let newValidation = validate();

        setValidation(newValidation);
        setDirty(true);

        let { firstName, lastName, email, username, password, confirmPassword, group, center, contact } = newValidation;
        let valid = firstName && lastName && email && username && password && confirmPassword && group && center && contact;

        if (valid) {
            props.onSave(closeDetails);
        }
    };

    const validate = () => {
        let newValidation = { ...validation };

        let re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        let { firstName, lastName, email, username, password, confirmPassword, groupId, centerId, contactId, isMicrositeCoach, courierVendor, opoId } = props.data;

        newValidation.firstName = firstName != '';
        newValidation.lastName = lastName != '';
        newValidation.email = email != '' && re.test(email);
        newValidation.username = username != '';
        newValidation.password = sendsVerification || !(props.data.id == 0 || password != '') ? true : password.length >= 6 && password.length <= 12;
        newValidation.confirmPassword = sendsVerification || !(props.data.id == 0 || password.length > 0) ? true : password == confirmPassword && confirmPassword != '';
        newValidation.group = groupId > 0;
        newValidation.center = props.isAdmin ? (groupId == UserGroup.CenterUser || groupId == UserGroup.CenterAdmin ? centerId > 0 : true) : true;
        newValidation.contact = props.isAdmin ? (isMicrositeCoach ? contactId > 0 : true) : true;
        newValidation.courierVendor = props.isAdmin ? (groupId == UserGroup.LogisticsProvider ? courierVendor > 0 : true) : true;
        newValidation.opo = props.isAdmin ? (groupId == UserGroup.Opo || groupId == UserGroup.OpoAdmin ? opoId > 0  : true ):true;

        return newValidation;
    };

    const isValid = () => {
        let { firstName, lastName, email, username, password, confirmPassword, group, center, contact } = validation;
        let isValid = firstName && lastName && email && username && password && confirmPassword && group && center && contact;
        return isValid;
    };

    const renderMainContent = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.firstName == false ? 'error' : null}>
                            <ControlLabel>First Name</ControlLabel>
                            <FormControl
                                type='text'
                                name='firstName'
                                value={props.data.firstName}
                                onChange={handleFieldChange}
                            />

                            {!validation.firstName && (
                                <ErrorWrapper marginLeft={0} className='error'>Please specify the user's first name</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>

                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.lastName == false ? 'error' : null}>
                            <ControlLabel>Last Name</ControlLabel>
                            <FormControl
                                type='text'
                                name='lastName'
                                value={props.data.lastName}
                                onChange={handleFieldChange}
                            />

                            {!validation.lastName && (
                                <ErrorWrapper marginLeft={0} className='error'>Please specify the user's last name</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.email == false ? 'error' : null}>
                            <ControlLabel>Email</ControlLabel>
                            <FormControl
                                type='text'
                                name='email'
                                value={props.data.email}
                                onChange={handleFieldChange}
                            />

                            {!validation.email && (
                                <ErrorWrapper marginLeft={0} className='error'>Please specify a valid email</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>

                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.username == false ? 'error' : null}>
                            <ControlLabel>Username</ControlLabel>
                            <FormControl
                                type='text'
                                id='username'
                                name='username'
                                autoComplete='off'
                                value={props.data.username}
                                onChange={handleFieldChange}
                            />

                            {!validation.username && (
                                <ErrorWrapper marginLeft={0} className='error'>Please specify a user name</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>
                </div>

                {sendsVerification && (
                    <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                        OPO Admins set their own password. We'll email them a link to verify their account once they're saved.
                    </Alert>
                )}

                <div style={{ display: sendsVerification ? 'none' : 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.password == false ? 'error' : null}>
                            <ControlLabel>Password *</ControlLabel>
                            <PasswordField
                                name='password'
                                value={props.data.password}
                                onChange={handlePasswordFieldChange}
                            />

                            {!validation.password && (
                                <ErrorWrapper marginLeft={0} className='error'>Please specify a valid password, 6-12 characters...</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>

                    <div style={{ width: '49%' }}>
                        <FormGroup validationState={dirty && validation.confirmPassword == false ? 'error' : null}>
                            <ControlLabel>Confirm Password *</ControlLabel>
                            <PasswordField
                                name='confirmPassword'
                                value={props.data.confirmPassword}
                                onChange={handlePasswordFieldChange}
                            />

                            {!validation.confirmPassword && (
                                <ErrorWrapper marginLeft={0} className='error'>Please make sure the passwords match</ErrorWrapper>
                            )}
                        </FormGroup>
                    </div>
                </div>
            </>
        );
    };

    const renderCenterContent = (title: string, button: string, valid: boolean) => {
        let roles = props.roles.filter(x => x.id >= 100 && x.id <= 180);

        return (
            <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        {!valid && (
                            <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>There are some issues that prevented us from saving the user...</Alert>
                        )}

                        {props.data.id != 0 && (
                            <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>* Only specify when you want to change the password...</Alert>
                        )}

                        {renderMainContent()}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={() => handleSave(true)}>{button}</Button>
                    <Button onClick={props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    };

    const renderAdminOnlyContent = () => {
        const coachList = _.sortBy(props.micrositeCoaches, item => item.description.toUpperCase())

        return (
            <>
                <FormGroup validationState={dirty && validation.group == false ? 'error' : null}>
                    <ControlLabel>Organ Type</ControlLabel>
                    <FormControl
                        componentClass='select'
                        name='organTypeId'
                        value={props.data.organTypeId}
                        onChange={handleFieldChange}
                    >
                        <option value={-1}>- EITHER -</option>
                        {props.organTypeList.map(item =>
                            <option key={'org-t-' + item.id} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>

                    {!validation.group && (
                        <ErrorWrapper marginLeft={0} className='error'>Please select a user group</ErrorWrapper>
                    )}
                </FormGroup>

                <FormGroup validationState={dirty && validation.group == false ? 'error' : null}>
                    <ControlLabel>User Group</ControlLabel>
                    <FormControl
                        componentClass='select'
                        name='groupId'
                        value={props.data.groupId}
                        onChange={handleFieldChange}
                    >
                        <option value={0}>- Select User Group -</option>
                        {props.userGroups.map(group =>
                            <option key={'group-' + group.id} value={group.id}>{group.name}</option>
                        )}
                    </FormControl>

                    {!validation.group && (
                        <ErrorWrapper marginLeft={0} className='error'>Please select a user group</ErrorWrapper>
                    )}
                </FormGroup>

                {(props.data.groupId == UserGroup.CenterUser || props.data.groupId == UserGroup.CenterAdmin) && (
                    <FormGroup validationState={dirty && validation.center == false ? 'error' : null}>
                        <ControlLabel>Center</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='centerId'
                            value={props.data.centerId}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>- Select Center -</option>
                            {props.centers.map(center =>
                                <option key={'center-' + center.id} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>

                        {!validation.center && (
                            <ErrorWrapper marginLeft={0} className='error'>Please select a center</ErrorWrapper>
                        )}
                    </FormGroup>
                )}

                {props.data.groupId == UserGroup.LogisticsProvider && (
                    <FormGroup validationState={dirty && validation.courierVendor == false ? 'error' : null}>
                        <ControlLabel>Courier Vendor</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='courierVendor'
                            value={props.data.courierVendor}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>- Select Courier Vendor -</option>
                            {props.courierVendors.map(item =>
                                <option key={'cv-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>

                        {!validation.center && (
                            <ErrorWrapper marginLeft={0} className='error'>Please select a center</ErrorWrapper>
                        )}
                    </FormGroup>
                )}

                {(props.data.groupId == UserGroup.Opo || props.data.groupId == UserGroup.OpoAdmin) && (
                    <FormGroup validationState={dirty && validation.opo == false ? 'error' : null}>
                        <ControlLabel>OPO</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='opoId'
                            value={props.data.opoId}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>- Select Center -</option>
                            {props.opoList.map(item =>
                                <option key={'opo-' + item.id} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>

                        {!validation.center && (
                            <ErrorWrapper marginLeft={0} className='error'>Please select an OPO</ErrorWrapper>
                        )}
                    </FormGroup>
                )}

                <FormGroup >
                    <ControlLabel>Microsite Coach?</ControlLabel>
                    <div style={{ marginLeft: 20, paddingTop: 0, paddingBottom: 0 }}>
                        <Radio inline name='isMicrositeCoach' value={1} checked={props.data.isMicrositeCoach} onChange={handleFieldChange}>Yes</Radio>
                        <Radio inline name='isMicrositeCoach' value={0} checked={!props.data.isMicrositeCoach} onChange={handleFieldChange}>No</Radio>
                    </div>
                </FormGroup>

                {props.data.isMicrositeCoach && (
                    <FormGroup validationState={dirty && validation.contact == false ? 'error' : null}>
                        <ControlLabel>Coach Contact</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='contactId'
                            value={props.data.contactId}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>- Select Contact -</option>
                            {coachList.map(contact =>
                                <option key={'contact-' + contact.id} value={contact.id}>{contact.description}</option>
                            )}
                        </FormControl>

                        {!validation.contact && (
                            <ErrorWrapper marginLeft={0} className='error'>Please select a contact</ErrorWrapper>
                        )}
                    </FormGroup>
                )}

                <FormGroup>
                    <ControlLabel>Send email when ticket assigned?</ControlLabel>
                    <div style={{ marginLeft: 20, paddingTop: 0, paddingBottom: 0 }}>
                        <Radio inline name='sendTicketNotification' value={1} checked={props.data.sendTicketNotification} onChange={handleFieldChange}>Yes</Radio>
                        <Radio inline name='sendTicketNotification' value={0} checked={!props.data.sendTicketNotification} onChange={handleFieldChange}>No</Radio>
                    </div>
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Is Deactivated?</ControlLabel>
                    <div style={{ marginLeft: 20, paddingTop: 0, paddingBottom: 0 }}>
                        <Radio inline name='isDeactivated' value={1} checked={props.data.isDeactivated} onChange={handleFieldChange}>Yes</Radio>
                        <Radio inline name='isDeactivated' value={0} checked={!props.data.isDeactivated} onChange={handleFieldChange}>No</Radio>
                    </div>
                </FormGroup>
            </>
        );
    };

    if (props.data == null) {
        return null;
    }

    const title = props.data.id == 0 ? 'Add User' : 'Edit User';
    const button = props.data.id == 0 ? 'Add User' : 'Save User';
    const valid = isValid();

    if (props.isAdmin)
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <h3 style={{ margin: 0 }}>{title}</h3>
                    <Button bsStyle='link' bsSize='sm' onClick={props.onCancel}><Glyphicon glyph='remove' /></Button>
                </div>

                {!valid && (
                    <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>There are some issues that prevented us from saving the user...</Alert>
                )}

                {props.data.id != 0 && (
                    <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5, textAlign: 'center' }}>* Only specify when you want to change the password...</Alert>
                )}

                <FormWrapper style={{ width: '99%' }}>
                    {renderMainContent()}

                    {renderAdminOnlyContent()}

                    {/* <FormGroup>
                        <ControlLabel>Roles</ControlLabel>
                        <Roles
                            roles={props.data.roles}
                            roleList={props.roles}
                            onToggleRole={props.onRoleChange} />
                    </FormGroup> */}

                    <Row style={{ marginTop: 20 }}>
                        <Col xs={12} lg={12} className='text-center'>
                            <Button bsStyle='primary' onClick={() => handleSave(true)}>{button} &amp; Close Details</Button>{' '}
                            <Button onClick={() => handleSave(false)}>{button}</Button>{' '}
                            <Button bsStyle='link' onClick={props.onCancel}>Cancel, Discard Any Changes</Button>
                        </Col>
                    </Row>
                </FormWrapper>
            </>
        );

    return renderCenterContent(title, button, valid);
}

export default AddEdit;
